/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AssistantSessionSummary = {
  /**
   * Number of messages created in the range
   */
  messages: number;
  /**
   * Number of sessions with activity in the range
   */
  sessions: number;
  /**
   * Cost in USD incurred in the range
   */
  totalCost: number;
  /**
   * Tokens consumed in the range
   */
  totalTokens: number;
};

/** @internal */
export const AssistantSessionSummary$inboundSchema: z.ZodMiniType<
  AssistantSessionSummary,
  unknown
> = z.pipe(
  z.object({
    messages: z.int(),
    sessions: z.int(),
    total_cost: z.number(),
    total_tokens: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "total_cost": "totalCost",
      "total_tokens": "totalTokens",
    });
  }),
);

export function assistantSessionSummaryFromJSON(
  jsonString: string,
): SafeParseResult<AssistantSessionSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AssistantSessionSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AssistantSessionSummary' from JSON`,
  );
}
